export default __webpack_public_path__ + "static/media/5b42eaca0625ac0b.a6ad95512b0ea77682118e4fd9140c65.svg";